module.exports = __webpack_public_path__ + "img/20200717_174826.8c4a1b5c.jpg";